// extracted by mini-css-extract-plugin
export var infoItem = "_rq-2";
export var title = "_rq-0";
export var value = "_rq-1";